import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { Component, VNode } from 'intact-vue-next';
import template from './index.vdt';
import { _$ } from '../../i18n';
import { useTransfer } from './useTransfer';
import { useFilter } from './useFilter';
import { useCheck } from './useCheck';
import { useConfigContext } from '../config';
var typeDefs = {
  data: Array,
  keyName: String,
  labelName: String,
  value: Array,
  leftCheckedKeys: Array,
  rightCheckedKeys: Array,
  filterable: Boolean,
  filter: Function,
  placeholder: String,
  leftKeywords: String,
  rightKeywords: String,
  leftTitle: [String, VNode],
  rightTitle: [String, VNode],
  enableAdd: Function,
  enableRemove: Function
};
var defaults = function defaults() {
  return {
    data: [],
    keyName: 'key',
    labelName: 'label',
    value: [],
    leftCheckedKeys: [],
    rightCheckedKeys: [],
    placeholder: _$('请输入'),
    leftTitle: _$('请选择'),
    rightTitle: _$('已选择')
  };
};
var events = {
  add: true,
  remove: true
};
export var Transfer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Transfer, _Component);
  function Transfer() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.transfer = useTransfer();
    _this.filter = useFilter(_this.transfer.rightData);
    _this.check = useCheck(_filterInstanceProperty(_this));
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Transfer.prototype;
  _proto.getData = function getData() {
    return this.transfer.rightData.value;
  };
  _proto.getCheckedData = function getCheckedData(model) {
    var data = _filterInstanceProperty(this).getFilterData(model);
    var _this$get = this.get(),
      keyName = _this$get.keyName;
    var checkedKeys = this.get(model + "CheckedKeys");
    return _filterInstanceProperty(data).call(data, function (item) {
      return ~checkedKeys.indexOf(item[keyName]);
    });
  };
  return Transfer;
}(Component);
Transfer.template = template;
Transfer.typeDefs = typeDefs;
Transfer.defaults = defaults;
Transfer.events = events;